(() => {
  const log = (...args) => console.log("[bz-variant-gallery]", ...args);

  function getMap() {
    const el = document.querySelector("[data-variant-gallery-map]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.innerText || "{}");
    } catch (e) {
      console.warn("[bz-variant-gallery] failed to parse JSON map", e);
      return null;
    }
  }

  function getVariantIdFromDom() {
    // Most themes keep the selected variant id in the add-to-cart hidden input
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input?.value ? String(input.value) : null;
  }

  function buildSlideLi(url, index) {
    const li = document.createElement("li");
    li.setAttribute("data-swiper-slide", "");
    // fake media id (unique per url/index) so gallery.js diffing works
    li.dataset.mediaId = `bz-${index}`;

    li.className = "swiper-slide";
    li.style.setProperty("--slide-ratio", "1");

    // Basic img. (If you want srcset/sizes later we can add it)
    const img = document.createElement("img");
    img.src = url;
    img.alt = "";
    img.width = 1100;
    img.loading = index > 0 ? "lazy" : "eager";
    img.fetchPriority = index === 0 ? "high" : "auto";
    img.className = "wt-product__img";
    img.setAttribute("data-media-id", `bz-${index}`);

    li.appendChild(img);
    return li;
  }

  function buildThumbLi(url, index) {
    const li = document.createElement("li");
    li.setAttribute("data-swiper-slide", "");
    li.className = "thumbs-list-item swiper-slide";
    li.dataset.slideMediaId = `bz-${index}`;
    li.style.setProperty("--thumb-ratio", "1");
    li.tabIndex = -1;

    const wrap = document.createElement("div");

    const img = document.createElement("img");
    img.src = url;
    img.alt = "";
    img.width = 300;
    img.loading = "lazy";
    img.className = "wt-product__img";
    img.setAttribute("data-media-id", `bz-${index}`);

    wrap.appendChild(img);
    li.appendChild(wrap);
    return li;
  }

  function applyVariantGallery(variantId) {
    const map = getMap();
    if (!map?.variants) {
      log("No map found");
      return;
    }

    const urls = map.variants[String(variantId)] || [];
    log("variantId:", variantId, "urls:", urls);

    // If metafield is empty for this variant, DO NOTHING (keep default product gallery)
    if (!Array.isArray(urls) || urls.length === 0) return;

    const gallerySection = document.querySelector("gallery-section.wt-product__gallery");
    if (!gallerySection) {
      log("gallery-section not found");
      return;
    }

    const galleryWrapper = gallerySection.querySelector('[data-gallery] [data-swiper-container]');
    const thumbsWrapper = gallerySection.querySelector('[data-thumbs] [data-swiper-container]');
    if (!galleryWrapper || !thumbsWrapper) {
      log("gallery/thumb wrappers not found");
      return;
    }

    // If gallery-section already has Swipers, destroy them cleanly (uses your class methods)
    try {
      gallerySection.destroyCarouselGallery?.();
    } catch (e) {
      // ignore
    }

    // Replace DOM slides
    galleryWrapper.innerHTML = "";
    thumbsWrapper.innerHTML = "";

    urls.forEach((url, idx) => {
      galleryWrapper.appendChild(buildSlideLi(url, idx));
      thumbsWrapper.appendChild(buildThumbLi(url, idx));
    });

    // IMPORTANT: update the cached "original slides" clones inside gallery-section
    // so your theme’s logic doesn’t revert to product.media later.
    try {
      gallerySection.readConfiguration?.();
    } catch (e) {
      // If readConfiguration isn’t accessible for some reason, we still try init
      console.warn("[bz-variant-gallery] readConfiguration failed", e);
    }

    // Re-init the gallery
    try {
      gallerySection.initializeGallery?.();
    } catch (e) {
      console.warn("[bz-variant-gallery] initializeGallery failed", e);
    }
  }

  // ---- Variant change detection (robust) ----
  function boot() {
    // 1) Apply once on load
    const initial = getVariantIdFromDom();
    if (initial) applyVariantGallery(initial);

    // 2) Watch the hidden variant input for changes
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input) {
      const mo = new MutationObserver(() => {
        const id = getVariantIdFromDom();
        if (id) applyVariantGallery(id);
      });
      mo.observe(input, { attributes: true, attributeFilter: ["value"] });

      // also catch programmatic input.value changes that don’t trigger mutation
      input.addEventListener("change", () => {
        const id = getVariantIdFromDom();
        if (id) applyVariantGallery(id);
      });
    }

    // 3) If your app fires a custom event, catch it too
    document.addEventListener("variant:changed", (e) => {
      const id = e?.detail?.variant?.id || e?.detail?.variantId;
      if (id) applyVariantGallery(String(id));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
